import { render } from "./ZNclasswide.vue?vue&type=template&id=37c5dcbc&scoped=true"
import script from "./ZNclasswide.vue?vue&type=script&lang=js"
export * from "./ZNclasswide.vue?vue&type=script&lang=js"

import "./ZNclasswide.vue?vue&type=style&index=0&id=37c5dcbc&lang=scss&scoped=true"
import "./ZNclasswide.vue?vue&type=style&index=1&id=37c5dcbc&lang=css"

import exportComponent from "D:\\workCode\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c5dcbc"]])

export default __exports__